export default class ForbiddenError extends Error {
  constructor() {
    super("");
    this.name = "ForbiddenError";
  }
}
